import styled from 'styled-components';
import { COLORS } from '@/theme';
import { InputNumber, Select } from '@/ui';

export const StyledSelect = styled(Select)`
  &&& {
    min-height: 40px;

    .ant-select-selector {
      overflow: hidden;
      padding-top: 0.15rem;
    }

    /* Keep the search caret/typed text aligned with the placeholder start
       (11px), so the cursor sits at the beginning of the word. */
    .ant-select-selection-search {
      inset-inline-start: 0.6875rem;
    }

    .ant-select-selection-search-input {
      padding: 0 !important;
    }

    .ant-select-selection-overflow {
      flex-wrap: nowrap !important;
      overflow: hidden;
      white-space: nowrap;

      & .ant-select-selection-overflow-item span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 8vw;
      }

      & .ant-select-selection-overflow-item-rest div {
        border: none;
        color: ${COLORS.GRAY_PRIMARY};
      }

      & .ant-select-selection-overflow-item-suffix {
        padding-left: 0.25rem;
      }
    }

    .ant-select-clear {
      inset-inline-end: 0.25rem;
      top: 50%;
      width: fit-content;
      height: fit-content;
    }
  }
`;

// Align the numeric filters with the text inputs / selects in the same row
// (same 40px height and border radius instead of the default shorter, square look).
export const StyledInputNumber = styled(InputNumber)`
  &&&.ant-input-number {
    min-height: 40px;
    border-radius: 0.5rem;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  &&& .ant-input-number-input-wrap {
    flex: 1;
  }

  &&& .ant-input-number-input {
    height: 38px !important;
  }
`;
